module.exports = __webpack_public_path__ + "img/HomeMEG300.9dc4f67e.png";